import { useState } from "react";
import { Button } from "react-bootstrap";
import * as BsIcons from "react-icons/bs";

function CopyButton({ text, label }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (err) {
            console.error("Copy failed:", err);
        }
    };

    return (
        <Button
            variant="secondary"
            onClick={handleCopy}
            aria-label={`Copy ${label}`}
            title={copied ? "Copied!" : "Copy"}
        >
            {copied ? <BsIcons.BsClipboardCheck /> : <BsIcons.BsClipboard />}
        </Button>
    );
}
export default CopyButton;